<template>
    <div>
        <b-input-group :prepend="name">
            <template v-slot:append>
                <b-btn variant="warning" :disabled="myIkey && code && !verified ? false : true" @click="verify">
                    Verify PIN
                </b-btn>
            </template>
            <b-input v-model="code" :name="name" max="4" class="myFeild" :placeholder="orderTypeId === 2 ? 'Optional' : 'Required'" v-validate="'required|length: 4'"/>
        </b-input-group>
        <p class="mt-2" :class="verifyText === 'PIN verified' ? 'text-success' : 'text-danger'">
            {{verifyText}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "pinCode",
        props: {
            name: {required: true, type: String},
            orderTypeId: {required: true, type: [String, Number]},
            myIkey: {required: true},
            value: {required: true},
            model: {required: true},
        },
        data () {
            return {
                code: null,
                verified: false,
                verifyText: ''
            }
        },
        methods: {
            getMobileWithOutMask (val) {
                if (val) {
                    return val.replace(/-/g, '')
                } else {
                    return ''
                }
            },
            verify () {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    myIkey: this.myIkey,
                    veriCode: this.code,
                    DestPhone: '+1' + this.getMobileWithOutMask(this.model.phoneNumber)
                }
                return this.$api.getRestaurant.VerifyOTP(model).then(res => {
                    if (res.success) {
                        this.verified = true
                        this.verifyText = 'PIN verified'
                        this.$emit('input', 'verified')
                    } else {
                        this.verified = false
                        this.verifyText = 'Wrong PIN.Please try again'
                        this.$emit('input', null)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
